// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M9.5 3.4V2.7C9.5 2.31 9.81 2 10.2 2H10.9M12.6 2H13.3C13.69 2 14 2.31 14 2.7V3.4M14 5.1V5.8C14 6.19 13.69 6.5 13.3 6.5H12.6M10.9 6.5H10.2C9.81 6.5 9.5 6.19 9.5 5.8V5.1',
  'M3 10H5.5C6.05 10 6.5 10.45 6.5 11V13.5C6.5 14.05 6.05 14.5 5.5 14.5H3C2.45 14.5 2 14.05 2 13.5V11C2 10.45 2.45 10 3 10Z',
  'M6.9 2.1H6.1C5 2.1 4.1 3 4.1 4.1V7.45M2.25 5.6L4.1 7.45L5.95 5.6',
];
